import { render, staticRenderFns } from "./TicketDetailsPage.vue?vue&type=template&id=4b2016d2"
import script from "./TicketDetailsPage.vue?vue&type=script&lang=js"
export * from "./TicketDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports